import React from "react";
import { HtmlViewer } from "../../plugin-html/viewer/html-viewer.js";
const EmbedViewer = ({ node, settings, iframeSandboxDomain }) => {
  const htmlCompProps = {
    htmlData: {
      ...node.embedData,
      html: unescape(node.embedData.oembed?.html ?? "")
    },
    settings,
    iframeSandboxDomain
  };
  return /* @__PURE__ */ React.createElement(HtmlViewer, { ...htmlCompProps });
};
export {
  EmbedViewer
};
//# sourceMappingURL=embed-viewer.js.map
